module.exports = __webpack_public_path__ + "img/bg_lottery_luck_small.cb0a9d2b.png";